// extracted by mini-css-extract-plugin
export default {"page":"dOigW3JHquyv7DQYXGy2","container":"WUMTuCwxdRzGBOZZm7qi","milestoneMsg":"SZcB05DbemVkoODu59oi","bold":"uumrtRSXJaXAvEdLEysi"};